<template>
  <o-view class="c-tickets">
    <o-nav-bar title="Producten" :has-close-button="true" />
    <o-product-list title="Tickets" :products="products" />
    <o-product-list title="My car" :products="mycar" />
    <o-product-list title="My bike" :products="mybike" />
  </o-view>
</template>

<script>
import OProductList from '@/components/OProductList.vue'

export default {
  name: 'Tickets',
  components: {
    OProductList
  },
  data() {
    return {
      products: [
        {
          label: 'Trein',
          icon: 'train',
          link: 'sales/train'
        },
        {
          label: 'Bus / metro / tram',
          icon: 'tram',
          link: 'sales/ov'
        },
        {
          label: 'Fiets',
          icon: 'bike',
          link: 'sales/bike'
        },
        {
          label: 'Auto',
          icon: 'car',
          link: 'sales/car'
        },
        {
          label: 'Parkeren',
          icon: 'parking',
          link: 'sales/parking/4411'
        },
        {
          label: 'Kortverhuur',
          icon: 'car'
        }
      ],
      mycar: [
        {
          label: 'VAB Assistance',
          icon: 'car',
          link: 'sales/assistance/vab'
        },
        {
          label: 'VAB Assistance (on demand)',
          icon: 'car'
        },
        {
          label: 'VAB Reisvignet',
          icon: 'car'
        }
      ],
      mybike: [
        {
          label: 'VAB Bike Assistance',
          icon: 'bike'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.c-tickets {
  background: $primary-color;
  background: var(--primary-color);
  color: #fff;
  position: relative;
  z-index: 20;
}

.slide-up-enter .c-tickets {
  opacity: 0;
}
</style>
